// 梁
import rlModelData from "./rlModelData";
import store from "@/store/index";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
class rlRingBeamData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  getPKPM_ringBeamData =
    store.state.globalData.rl_wasm_module.getPKPM_ringBeamData;
  constructor() {
    super();
    this.componentType = "ringBeam";
    // 顶点数据
    this.points = [];
    this.deviation = -0.0003;
    // this.Name = null;
    // this.m_sectParamData = {}; //截面源数据
    // this.SectData = []; //截面组合数据
    this.m_gridData = {}; //网格数据
    this.Ecc = null; //梁偏轴距离
    this.HDiff1 = null; //梁顶标高1
    this.HDiff2 = null; //梁顶标高2

    this.Attribute = 2; //默认为一般构件
    this.classTypeName = "rlRingBeamSeg"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识
    this.Color = null;
    // (this.rlLayer && this.rlLayer[0] && this.rlLayer[0].storey) || "#00b4b4"; //构件颜色
    this.ModelType = "圈梁";
    //this.Layer = "rlBeamSeg"; //图层名称
    this.m_groupName = "rlRingBeamGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据
  }

  initData(obj) {
    super.initData(obj);
    this.m_gridData = obj.m_gridData;
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;

    this.Color = obj.Color;
    // this.Layer = obj.Layer ? obj.Layer : "rlBeamSeg";

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = this.m_gridData = getEntityData({
      Guid: obj.m_gridData,
      classTypeName: "rlGrid",
    }); //rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    this.Ecc = obj.Ecc;
    this.HDiff1 = obj.HDiff1;
    this.HDiff2 = obj.HDiff2;
  }

  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let res = this.getPKPM_ringBeamData(
        this.m_sectParamData.Kind,
        this.m_sectParamData.ShapeVal,
        this.m_gridData.m_stJoint.m_pt[0],
        this.m_gridData.m_stJoint.m_pt[1],
        this.m_gridData.m_edJoint.m_pt[0],
        this.m_gridData.m_edJoint.m_pt[1],
        this.LevelB,
        this.Height,
        this.Ecc,
        this.HDiff1,
        this.HDiff2
      );
      if (!res) return;
      this.getModelDrawData(JSON.parse(res));
      let wasmData = JSON.parse(res);
      let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      let data3D = this.getModel3dData(data);
      if (!data3D) return;

      data3D = JSON.parse(data3D)["3D"][this.Guid];
      this.points = data3D.Points;
      this.index3dData = {
        points: data3D.Points,
        faces: data3D["3dFaces"].map((item) => item.index).flat(),
      };
    } else {
      this.index2dData = this.index2dData.split(",").map(Number);
    }
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
      this.CurrtSect = sectString;
    }
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    // this.index3dData = modelData["3D"]["3dFaces"]
    //   .map((item) => item.index)
    //   .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
    this.OtherData = JSON.stringify(modelData);
  }

  // 克隆方法
  async myClone() {
    let newObj = new rlRingBeamData();
    super.cloneData(newObj);
    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.Color = this.Color;
    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  draw() {
    super.draw();
    if (this.m_JointData) {
      this.m_gridData.m_ringBeamId = this.Guid;
    }
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.Guid;
    data["Ecc"] = this.Ecc;
    data["HDiff1"] = this.HDiff1;
    data["HDiff2"] = this.HDiff2;

    return data;
  }

  // 删除
  async erase() {
    this.m_gridData ? (this.m_gridData.m_ringBeamId = null) : "";
    await super.erase();
  }
}

export { rlRingBeamData };
